import React from 'react';
import Loader from '../../shared/loader';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import ReactModal from 'react-modal';
ReactModal.setAppElement('body');

const ModalStyles = {
  overlay: {
	  backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content : {
  	padding				        : '1rem',
	  width				          : 'auto',
	  maxWidth			        : '800px',
	  height				        : 'auto',
    maxHeight             : '90%',
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

class PriceSelect extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			times: [],
			showTimesModal: false,
			loading: false
		}
	}

	handleCloseModal = () => {
		this.setState({ showTimesModal: false });
	}

	handleButtonClick = ( event ) => {
		event.preventDefault();
		this.getTimes();
	}

	getTimes = () => {
		this.setState({ showTimesModal: true, loading: true }, function() {
			const url = '/products/' + this.props.product.id + '/times';
			axios.post( url, {
					authenticity_token: this.props.token,
					id: this.props.productId,
					date: this.props.date.format('DD/MM/YYYY')
			}).then( response => {
				this.setState({
					times: response.data,
					loading: false
				});
			}).catch(err => {
				console.log(err);
			});
		});
	}

	selectPrice = (obTime, event ) => {
		event.preventDefault();
		this.setState({buttonLabel: obTime.time, showTimesModal: false}, function() {
			this.props.selectPrice( obTime );
		});
	}

	reOpen = () => {
		this.setState({ buttonLabel: this.props.buttonLabel }, function() {
			this.getTimes();
		});
	}


	render() {
		return (
			<div className="input-group prices">

				<button onClick={this.handleButtonClick} className="button time-btn" disabled={!this.props.active} type="button">{this.props.selected.length > 0 ? this.props.selected : 'Time'}<span className="icon icon-down" aria-hidden="true"></span></button>

				<ReactModal isOpen={this.state.showTimesModal} contentLabel="Login/Register" style={ModalStyles}>

					<button onClick={this.handleCloseModal} className="close-button" aria-label="Close modal">
						<span aria-hidden="true">×</span>
					</button>

          <div className="select-product-box">
            <div className="grid-x grid-margin-x">
              <div className="cell small-2">
                <span className="icon icon-info"></span>
              </div>
              <div className="cell small-10">
                <h4>Please select a time slot for the <strong>{this.props.product.name}</strong></h4>
              </div>
            </div>
          </div>
          <br/>

					{ this.state.loading ? (
						<Loader />
					) : (
						<div className="time-availability">
						{ this.state.times.length > 0 ? (
							<PriceList
								times={this.state.times}
								selectPrice={this.selectPrice}
                date={this.props.params.date != null ? this.props.params.date.format('dddd, Do MMMM ') : null}
							/>
						) : (
							<p>Sorry there is no availability on
              <b> {this.props.params.date != null ? this.props.params.date.format('dddd, Do MMMM') : null}</b>
             . The supplier may only hold their activity on certain days, or at the weekend. Please try another day.</p>
						)}
						</div>
					)}
				</ReactModal>
			</div>
		)
	}
}

const PriceList = props => (
	<div className="time-slot-content" >
    <span className="date-container"><b><span className="icon icon-calendar"></span> {props.date}</b></span>
		{props.times.map((time, index) => {
			return (
			<div className="time-slot-container" key={`time-` + time.id}>
				<div className="grid-x grid-margin-x">
					<div className="small-4 medium-4 cell">
            <div className="time-container">
						  <span className="icon icon-time"></span> <span className="time">{time.time}</span>
            </div>
					</div>
					<div className="small-4 medium-5 cell">
            <div className="price-container">
  						<span className="price">
  							<NumberFormat value={time.price} displayType={'text'} thousandSeparator={true} prefix={'£'} decimalScale={2} fixedDecimalScale={true} />
  						</span>
            </div>
					</div>
					<div className="small-4  medium-3  cell">
						<a className="button primary expanded price-item" name={time.time} onClick={(event) => props.selectPrice(time,event)}>Select</a>
					</div>
				</div>
			</div>
			)
		})}
	</div>
);
export default PriceSelect
